import { render, staticRenderFns } from "./terms-and-conditions.vue?vue&type=template&id=8e4c0f88&scoped=true"
var script = {}
import style0 from "./terms-and-conditions.vue?vue&type=style&index=0&id=8e4c0f88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4c0f88",
  null
  
)

export default component.exports